/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Accessibility_TitleInputs */

const he_seo_accessibility_title = /** @type {(inputs: Seo_Accessibility_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הצהרת נגישות - Pricedrop`)
};

const en_seo_accessibility_title = /** @type {(inputs: Seo_Accessibility_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accessibility Statement - Pricedrop`)
};

/**
* | output |
* | --- |
* | "Accessibility Statement - Pricedrop" |
*
* @param {Seo_Accessibility_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const seo_accessibility_title = /** @type {((inputs?: Seo_Accessibility_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Accessibility_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_seo_accessibility_title(inputs)
	return en_seo_accessibility_title(inputs)
});